export default {
    breadcrumbs: {
        my_companies: 'My companies',
    },
    buttons: {
        create_company: '+ Create company',
    },
    card: {
        pib: 'PIB',
    },
    no_companies: 'You have no added companies',
    no_peronal_info: 'Please fill first name, last name, and phone number',
}
